module.exports = __webpack_public_path__ + "img/intro03.d21ca71a.png";